/**
 * 解析文件名组成部分
 * @param filepath 完整文件路径或文件名
 * @returns 包含文件名和后缀的对象
 *
 * // 示例：
 * parseFileName("image.png")             // → {name: "image", ext: "png"}
 * parseFileName("archive.tar.gz")        // → {name: "archive.tar", ext: "gz"}
 * parseFileName(".gitignore")            // → {name: ".gitignore", ext: ""}
 * parseFileName("file.name.txt")         // → {name: "file.name", ext: "txt"}
 * parseFileName("/path/to/file.config.js") // → {name: "file.config", ext: "js"}
 * parseFileName("README")                // → {name: "README", ext: ""}
 * parseFileName("invalid.")              // → {name: "invalid.", ext: ""}
 */
export function parseFileName(filepath) {
    if (!filepath)
        return { name: '', ext: '' };
    // 提取纯文件名（处理路径）
    const basename = filepath.split(/[/\\]/).pop() || '';
    // 查找最后一个有效点位置
    const lastDotIndex = basename.lastIndexOf('.');
    // 判断无效后缀场景
    const isInvalidExtension = lastDotIndex === -1 || // 没有后缀
        lastDotIndex === 0 || // 隐藏文件
        lastDotIndex === basename.length - 1; // 以点结尾
    if (isInvalidExtension) {
        return {
            name: basename,
            ext: '',
        };
    }
    // 分割文件名和后缀
    return {
        name: basename.slice(0, lastDotIndex),
        ext: basename.slice(lastDotIndex + 1).toLowerCase(),
    };
}
export const isOverSize = (file, size) => {
    const isOver = file.size / 1024 / 1024 <= size;
    if (!isOver) {
        return false;
    }
    return isOver;
};
export const isImg = (file) => {
    const isJpgOrPng = file.type === 'image/jpeg' ||
        file.type === 'image/png' ||
        file.type === 'image/jpg';
    if (file.name.endsWith('.jfif')) {
        return false;
    }
    if (!isJpgOrPng) {
        return false;
    }
    return isJpgOrPng;
};
